/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrgQueryResult from './OrgQueryResult';

/**
 * The OrgOutputOrgs model module.
 * @module model/OrgOutputOrgs
 * @version 1.0
 */
class OrgOutputOrgs {
    /**
     * Constructs a new <code>OrgOutputOrgs</code>.
     * @alias module:model/OrgOutputOrgs
     */
    constructor() { 
        
        OrgOutputOrgs.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrgOutputOrgs</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrgOutputOrgs} obj Optional instance to populate.
     * @return {module:model/OrgOutputOrgs} The populated <code>OrgOutputOrgs</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrgOutputOrgs();

            if (data.hasOwnProperty('orgs')) {
                obj['orgs'] = ApiClient.convertToType(data['orgs'], [OrgQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/OrgQueryResult>} orgs
 */
OrgOutputOrgs.prototype['orgs'] = undefined;






export default OrgOutputOrgs;

